module.exports = __webpack_public_path__ + "static/img/areaA-20.788db84.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/ワンダーエージェント_イラスト/areaA-20.png
// module id = 932
// module chunks = 1